import { compactInteger } from 'humanize-plus';
export function humanizeNumber(statValue) {
  const humanify = statValue && typeof statValue === 'number' && statValue.toString().length > 2;
  return humanify ? compactInteger(statValue, 2) : statValue;
}



// WEBPACK FOOTER //
// ./src/Utils/NumberUtils.js